import gql from 'graphql-tag';

export const FOLLOW_OR_UNFOLLOW_USER = gql`
  mutation FollowOrUnfollowUser($input: FollowOrUnFollowUserInput!) {
    followOrUnfollowUser(input: $input)
  }
`;
